/** Decorative top crop: it fills the existing intro without reserving image height. */
export default function CompactHeaderBackground(
  { src }: { src: string | null | undefined },
) {
  if (!src) return null;
  return (
    <span aria-hidden="true" className="ta-compact-header-background">
      {/* Poster and cover assets use the existing approved public image hosts. */}
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src={src}
        alt=""
        className="h-full w-full object-cover object-top"
        loading="eager"
      />
      <span className="absolute inset-0 bg-[linear-gradient(90deg,rgba(8,30,34,.88),rgba(8,30,34,.60)),linear-gradient(0deg,rgba(8,30,34,.65),transparent)]" />
    </span>
  );
}
